import React from 'react';
import { Link } from 'react-router-dom';
import '../OtherVideos/other.css';

function DanceForm() {
  return (
    <div className="charlie-page">
      <h1 className="charlie-title">💃 Indian Dance Forms Showcase</h1>

      <div className="charlie-table-container">
        <table className="charlie-table">
          <thead>
            <tr>
              <th>Dance Form</th>
              <th>Region / State</th>
              <th>Category</th>
              <th>Key Features</th>
              <th>View Performance</th>
            </tr>
          </thead>
          <tbody>
            {danceData.map((item, index) => (
              <tr key={index}>
                <td>{item.scene}</td>
                <td>{item.themes}</td>
                <td>{item.category}</td>
                <td>{item.interpretation}</td>
                <td>
                  <iframe
                    className="charlie-iframe"
                    src={item.video}
                    title={item.scene}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/zones" className="back-button">
          ⬅ Back to Museum Realms
        </Link>
      </div>
    </div>
  );
}

const danceData = [
  {
    scene: "Bharatanatyam",
    themes: "Tamil Nadu",
    category: "Classical",
    interpretation: "Devotional, temple dance, strong postures, mudras",
    video: "https://www.youtube-nocookie.com/embed/Oyi7yuzdWY8?rel=0&modestbranding=1"
  },
  {
    scene: "Kathak",
    themes: "Uttar Pradesh",
    category: "Classical",
    interpretation: "Storytelling, spins, intricate footwork, Mughal influence",
    video: "https://www.youtube-nocookie.com/embed/e3I2UZiJCI8?rel=0&modestbranding=1"
  },
  {
    scene: "Kathakali",
    themes: "Kerala",
    category: "Classical",
    interpretation: "Dramatic storytelling with masks and makeup, expressive gestures",
    video: "https://www.youtube-nocookie.com/embed/GBbcYtkqVKQ?rel=0&modestbranding=1"
  },
  {
    scene: "Mohiniyattam",
    themes: "Kerala",
    category: "Classical",
    interpretation: "Feminine, graceful movements, semi-classical",
    video: "https://www.youtube-nocookie.com/embed/jZfXl8tceuQ?rel=0&modestbranding=1"
  },
  {
    scene: "Kuchipudi",
    themes: "Andhra Pradesh",
    category: "Classical",
    interpretation: "Fast rhythmic footwork, graceful body movements",
    video: "https://www.youtube-nocookie.com/embed/ko5sKNuSLbs?rel=0&modestbranding=1"
  },
  {
    scene: "Manipuri",
    themes: "Manipur",
    category: "Classical",
    interpretation: "Smooth, flowing movements, spiritual themes",
    video: "https://www.youtube-nocookie.com/embed/BUt3W9ZYUDI?rel=0&modestbranding=1"
  },
  {
    scene: "Odissi",
    themes: "Odisha",
    category: "Classical",
    interpretation: "Sculptural poses, tribhanga posture, devotional",
    video: "https://www.youtube-nocookie.com/embed/llIxMQT4MUM?rel=0&modestbranding=1"
  },
  {
    scene: "Sattriya",
    themes: "Assam",
    category: "Classical",
    interpretation: "Monastic origin, devotional themes, energetic steps",
    video: "https://www.youtube-nocookie.com/embed/8XLFAbRSbeA?rel=0&modestbranding=1"
  },
  {
    scene: "Chhau",
    themes: "Odisha / Jharkhand / WB",
    category: "Semi-Classical",
    interpretation: "Martial arts influence, tribal themes",
    video: "https://www.youtube-nocookie.com/embed/MWBJIobn-HY?rel=0&modestbranding=1"
  },
  {
    scene: "Bhangra",
    themes: "Punjab",
    category: "Folk",
    interpretation: "High-energy, celebratory, harvest dance",
    video: "https://www.youtube-nocookie.com/embed/ycTlIyQ2MHg?rel=0&modestbranding=1"
  },
  {
    scene: "Ghoomar",
    themes: "Rajasthan",
    category: "Folk",
    interpretation: "Circular patterns, graceful twirls, royal women’s dance",
    video: "https://www.youtube-nocookie.com/embed/cVeMyeTi4gE?rel=0&modestbranding=1"
  },
  {
    scene: "Garba / Dandiya",
    themes: "Gujarat",
    category: "Folk",
    interpretation: "Circular dance with sticks, Navratri theme",
    video: "https://www.youtube-nocookie.com/embed/noZVYsrg6bs?rel=0&modestbranding=1"
  },
  {
    scene: "Lavani",
    themes: "Maharashtra",
    category: "Folk",
    interpretation: "Expressive, sensuous, fast-paced beat",
    video: "https://www.youtube-nocookie.com/embed/wv0XBy-lEAo?rel=0&modestbranding=1"
  },
  {
    scene: "Yakshagana",
    themes: "Karnataka",
    category: "Folk-Classical",
    interpretation: "Theatrical, mythological stories, elaborate costumes",
    video: "https://www.youtube-nocookie.com/embed/LNGZ1R8QjuY?rel=0&modestbranding=1"
  },
  {
    scene: "Dollu Kunitha",
    themes: "Karnataka",
    category: "Folk",
    interpretation: "Drum-based energetic group dance",
    video: "https://www.youtube-nocookie.com/embed/LNGZ1R8QjuY?rel=0&modestbranding=1"
  },
  {
    scene: "Bihu",
    themes: "Assam",
    category: "Folk",
    interpretation: "Fast-paced, joyous, linked to spring festival",
    video: "https://www.youtube-nocookie.com/embed/c5oduySr6fo?rel=0&modestbranding=1"
  },
  {
    scene: "Kalbeliya",
    themes: "Rajasthan",
    category: "Folk",
    interpretation: "Serpent-inspired movements, traditional tribe-based",
    video: "https://www.youtube-nocookie.com/embed/kpsP9EoM8IA?rel=0&modestbranding=1"
  },
  {
    scene: "Gotipua",
    themes: "Odisha",
    category: "Folk-Classical",
    interpretation: "Boys dressed as girls, precursor to Odissi",
    video: "https://www.youtube-nocookie.com/embed/u5HA7gA1SQU?rel=0&modestbranding=1"
  }
];

export default DanceForm;
